export * from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Institution.vue?vue&type=template&id=da0d1628&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/sessions/sections/Institution.vue?vue&type=template&id=da0d1628&scoped=true&
// module id = 1541
// module chunks = 0